import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { HeartFilled } from '@components/main-components/media/icons/HeartFilled';
import type { ReleaseType } from '@graphql/reactQuery';
import { DataTestId } from '@utils/test';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const LikeSoundMenuItem = ({
  liked,
  onClick,
  releaseId,
  releaseType,
}: {
  liked: boolean;
  onClick: () => void;
  releaseId: string;
  releaseType: ReleaseType;
}) => {
  // Once albums become a feature on Sound we would want to have a different UX for liking albums
  if (releaseType === 'ALBUM') return null;

  return (
    <DropdownMenuItem
      data-testid={DataTestId.LIKE_SOUND_MENU_ITEM_DROPDOWN}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
    >
      {liked ? <HeartFilled uuid={releaseId} /> : <FontAwesomeIcon icon={faHeart} size="lg" />}
      <MenuItemLabel>{liked ? 'Unlike Sound' : 'Like Sound'}</MenuItemLabel>
    </DropdownMenuItem>
  );
};
